import type { ReactNode } from 'react';

// UX-23 — extrait de `apps/web-parent/src/pages/Home.tsx` (seule implémentation
// GÉNÉRIQUE de ce pattern — pastille arrondie colorée, texte libre en `children`
// — trouvée dans ce monorepo, vérifiée par grep AVANT tout code, comme demandé)
// vers `packages/ui` — ne duplique pas un composant déjà existant sous un nom
// différent, même précédent qu'`Avatar`/`getInitials` (UX-11B).
//
// ⚠️ DISTINCT de `apps/web-admin/src/pages/Enrollments.tsx#StatusTag` — un
// composant DIFFÉRENT qui partage seulement le nom (signature `{status:
// EnrollmentReviewStatus}`, pas `{children, tone}` générique) : PAS extrait
// ici, hors périmètre de ce ticket, jamais la même abstraction malgré le nom
// identique.
// UX-40 — ton `green` AJOUTÉ (extension purement ADDITIVE : aucun appelant
// existant ne change de comportement). Nécessaire pour la règle sémantique
// "vert = positif définitif" (voir
// `apps/web-parent/src/lib/enrollmentCardStatus.ts`) : `brand` vaut le teal de
// marque (`#0B5563`, `packages/ui/src/theme.css`, IDENTIQUE dans les deux apps
// depuis UX-17) — un token de MARQUE, jamais une couleur SÉMANTIQUE de succès,
// distinction déjà actée par le commentaire de tête d'`apps/web-parent/src/
// index.css`. Classes reprises TELLES QUELLES de `OverdueInvoices.tsx#LOW`
// (DSH-03, `bg-green-100 text-green-800`), déjà la teinte de succès de ce
// projet — jamais une nouvelle palette inventée.
export type StatusTagTone = 'amber' | 'gray' | 'blue' | 'brand' | 'red' | 'green';

const TONE_CLASSNAMES: Record<StatusTagTone, string> = {
  amber: 'bg-amber-100 text-amber-800',
  gray: 'bg-surface-raised text-text-secondary',
  blue: 'bg-blue-100 text-blue-800',
  brand: 'bg-brand-100 text-brand-700',
  red: 'bg-red-100 text-red-800',
  green: 'bg-green-100 text-green-800',
};

export function StatusTag({ children, tone }: { children: ReactNode; tone: StatusTagTone }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${TONE_CLASSNAMES[tone]}`}>
      {children}
    </span>
  );
}
